import { prefetchPartnersGridViewAndForm } from "./PartnersGridPage";
import type { NavigationItemType } from "../../root/layout/SidebarMenuItem";
import type { Paths } from "../../shared/usePrivacyNavigate";
import { partnersGridPageRoutes } from "./PartnersGridPage";

export const route: NavigationItemType["route"] = { path: "partners", children: partnersGridPageRoutes };
export const to = (paths: Paths) => paths.partnersGrid();
export const prefetch = () => void prefetchPartnersGridViewAndForm();
